import { render, staticRenderFns } from "./cover-component.vue?vue&type=template&id=4d38ccb9&scoped=true"
import script from "./cover-component.vue?vue&type=script&lang=js"
export * from "./cover-component.vue?vue&type=script&lang=js"
import style0 from "./cover-component.vue?vue&type=style&index=0&id=4d38ccb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38ccb9",
  null
  
)

export default component.exports